import Switch from "src/components/form/Switch";
import Form from "src/components/forms/TaskForm/Form";
import useTaskForm from "src/hooks/api/tasks/useTaskForm";
import { useTranslation } from "react-i18next";
import { TaskFormOptions } from "src/components/forms/TaskForm";

interface VisibilityFormProps extends TaskFormOptions {}

const VisibilityForm = ({ hideButtons }: VisibilityFormProps) => {
	const { t } = useTranslation("forms", {
		keyPrefix: "target-form",
	});
	const { task, actions, current } = useTaskForm();

	const getNextDisabled = () => {
		return !(task.start_date && (task.category_id || task.category));
	};

	return (
		<Form
			{...{ hideButtons }}
			title={t("title")}
			value={{
				is_private: task.is_private,
			}}
			onSubmit={async () => {
				actions.updateCurrent(current + 1);
			}}
			nextDisabled={getNextDisabled()}
		>
			{(getInputProps) => {
				return (
					<>
						<Switch
							label={t("anonymous")}
							value={task?.is_anonymous || false}
							onChange={(value) => {
								actions.set({
									is_anonymous: value,
								});
							}}
						/>
						<Switch
							label={t("private.label")}
							subLabel={t("private.sub-label")}
							value={task?.is_private || false}
							onChange={(value) => {
								actions.set({
									is_private: value,
								});
							}}
						/>
					</>
				);
			}}
		</Form>
	);
};

export default VisibilityForm;
